export function AnimatedIndicator() {
  return (
    <div className='absolute -top-1.5 -right-1.5'>
      <span className='relative flex size-3'>
        <span className='absolute inline-flex size-full animate-ping rounded-full bg-primary opacity-75'></span>
        <span className='relative inline-flex size-3 rounded-full bg-primary'></span>
      </span>
    </div>
  );
}
